export default "__VITE_ASSET__ebd3eadb__"